import React from 'react';
import { useParams } from 'react-router-dom';
import { useGroup } from '../hooks/useGroup';
import ScheduleForm from '../components/ScheduleForm';

const ScheduleAdd = () => {
  const { groupId } = useParams();
  const { group, addSchedule } = useGroup(groupId!);
  if (!group) {
    return <div>null</div>;
  }

  return <ScheduleForm group={group} addSchedule={addSchedule} />;
};

export default ScheduleAdd;
